/* eslint-disable */
import * as invariantModule from 'tiny-invariant';
const invariant = (invariantModule as any).default || invariantModule;

export { invariant };
